class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }
  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }
  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});
    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });
    document.body.classList.add('overflow-hidden');
  }
  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }
  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');
    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }
    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });
    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }
  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));
    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }
  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define('cart-drawer', CartDrawer);
class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}
customElements.define('cart-drawer-items', CartDrawerItems);
if (!window.GosCartRecommendationEngine) {
  window.GosCartRecommendationEngine = true;

  const shuffleGosCandidates = (items) => {
    const shuffled = [...items];
    for (let index = shuffled.length - 1; index > 0; index -= 1) {
      const swapIndex = Math.floor(Math.random() * (index + 1));
      [shuffled[index], shuffled[swapIndex]] = [shuffled[swapIndex], shuffled[index]];
    }
    return shuffled;
  };

  const shuffleGosCartRecommendations = (rack) => {
    const track = rack?.querySelector('.gos-cart-recommendations__track');
    if (!track) return;

    const maximumVisibleRecommendations = 9;
    const relatedRecommendationLimit = 4;
    const candidates = [...track.querySelectorAll('[data-gos-recommendation-card]')];
    if (candidates.length <= maximumVisibleRecommendations) {
      candidates.forEach((candidate) => {
        candidate.hidden = false;
        candidate.dataset.gosSelected = 'true';
      });
      rack.dataset.gosShuffled = 'true';
      return;
    }

    candidates.forEach((candidate) => {
      candidate.hidden = true;
      candidate.removeAttribute('data-gos-selected');
    });

    const related = candidates.filter((candidate) => candidate.dataset.gosRecommendationSource === 'related');
    const bestSellers = shuffleGosCandidates(candidates.filter((candidate) => candidate.dataset.gosRecommendationSource === 'best-seller'));
    const selected = related.slice(0, relatedRecommendationLimit);
    bestSellers.some((candidate) => {
      if (!selected.includes(candidate)) selected.push(candidate);
      return selected.length === maximumVisibleRecommendations;
    });
    if (selected.length < maximumVisibleRecommendations) {
      [...related.slice(relatedRecommendationLimit), ...shuffleGosCandidates(candidates)].some((candidate) => {
        if (!selected.includes(candidate)) selected.push(candidate);
        return selected.length === maximumVisibleRecommendations;
      });
    }

    selected.forEach((candidate) => {
      candidate.hidden = false;
      candidate.dataset.gosSelected = 'true';
      track.append(candidate);
    });
    rack.dataset.gosShuffled = 'true';
    track.scrollLeft = 0;
  };

  const loadGosCartRecommendations = async (drawer, reshuffle = false) => {
    if (!drawer.classList.contains('active')) return;
    const rack = drawer.querySelector('[data-gos-cart-recommendations]');
    if (!rack) return;
    if (reshuffle || rack.dataset.gosShuffled !== 'true') shuffleGosCartRecommendations(rack);
    if (rack.dataset.gosRecommendationsLoaded === 'true' || rack.dataset.gosRecommendationsLoading === 'true') return;
    const url = rack.dataset.gosRecommendationsUrl;
    if (!url) return;

    rack.dataset.gosRecommendationsLoading = 'true';
    try {
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Recommendation request failed');
      const html = await response.text();
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const replacement = documentFragment.querySelector('[data-gos-cart-recommendations]');
      if (replacement) {
        rack.replaceWith(replacement);
        shuffleGosCartRecommendations(replacement);
      }
    } catch (error) {
      rack.dataset.gosRecommendationsLoading = 'false';
    }
  };

  const connectGosCartRecommendationEngine = () => {
    document.querySelectorAll('cart-drawer').forEach((drawer) => {
      if (drawer.dataset.gosRecommendationEngineConnected === 'true') return;
      drawer.dataset.gosRecommendationEngineConnected = 'true';
      const observer = new MutationObserver((mutations) => {
        const drawerWasOpened = mutations.some((mutation) => mutation.type === 'attributes');
        const rackWasReplaced = mutations.some((mutation) => mutation.type === 'childList' && [...mutation.addedNodes].some((node) => {
          return node.nodeType === 1 && (node.matches?.('[data-gos-cart-recommendations]') || node.querySelector?.('[data-gos-cart-recommendations]'));
        }));
        if (drawerWasOpened) loadGosCartRecommendations(drawer, true);
        else if (rackWasReplaced) loadGosCartRecommendations(drawer);
      });
      observer.observe(drawer, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
      loadGosCartRecommendations(drawer, true);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', connectGosCartRecommendationEngine, { once: true });
  } else {
    connectGosCartRecommendationEngine();
  }
}
